import { reflectKeys } from "@utils/key.reflactor.ts";

export const ANNOTATION_RICHTEXT_EDITOR_OPTIONS = reflectKeys(["RECORDING", "DRAWING"]);

export const SUBJECT_CATEGORY = {
  MOE: "MOE",
  SCHM: "SCHM",
  SCHB: "SCHB",
} as const;

export type SubjectCategory = keyof typeof SUBJECT_CATEGORY;

export const MEDIA_OBJECT_FILE_STATUS = {
  READY: "READY",
  PROCESSING: "PROCESSING",
  TRANSCODING_ERROR: "TRANSCODING_ERROR",
  HTML5_UNZIP_ERROR: "HTML5_UNZIP_ERROR",
  ERROR: "ERROR",
  UPLOADING: "UPLOADING",
  SCANNING: "SCANNING",
  PROTECTED: "PROTECTED",
  VIRUS: "VIRUS",
  NOT_REQUIRED: "NOT_REQUIRED",
} as const;

export type MediaObjectFileStatus = keyof typeof MEDIA_OBJECT_FILE_STATUS;

export const MEDIA_OBJECT_TYPE = {
  AUDIO: "AUDIO",
  HTML5: "HTML5",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  EXCEL: "EXCEL",
  POWERPOINT: "POWERPOINT",
  WORD: "WORD",
  PDF: "PDF",
  ZIP: "ZIP",
  OTHERS: "OTHERS",
} as const;

export type MediaObjectType = keyof typeof MEDIA_OBJECT_TYPE;

export const RESOURCE_STATUS = {
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  PENDING_UNPUBLISH: "PENDING_UNPUBLISH",
  APPROVED: "APPROVED",
  UNPUBLISHED: "UNPUBLISHED",
  REJECTED: "REJECTED",
  ARCHIVED: "ARCHIVED",
} as const;

export type ResourceStatus = keyof typeof RESOURCE_STATUS;

export const RESOURCE_DOMAIN = {
  MOE: "MOE",
  COMMUNITY: "COMMUNITY",
  PERSONAL: "PERSONAL",
  APP: "APP",
  ASSIGNMENT: "ASSIGNMENT",
} as const;

export type ResourceDomain = keyof typeof RESOURCE_DOMAIN;

export const APP_TYPE = {
  LTI13: "LTI13",
  INTEGRATOR: "INTEGRATOR",
} as const;

export type AppType = keyof typeof APP_TYPE;

export const EMBED_OPTION = {
  EMBED_URL: "embed-url",
  EMBED_CODE: "embed-code",
} as const;

export type EmbedOption = (typeof EMBED_OPTION)[keyof typeof EMBED_OPTION];

export const EXTRA_HEIGHT = 4;
